import { Box, Button, Typography } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';

import { EmptyViewProps } from './props';

export const EmptyView: React.FC<EmptyViewProps> = (props) => {
  const {
    imgSrc,
    title,
    description,
    buttonText,
    buttonLink,
    titleProps,
    descriptionProps,
    buttonProps,
    buttonContainerProps,
    buttonLinkProps,
    enableButton = true,
  } = props;

  // ======================= VIEWS
  return (
    <Box className={'py-14 flex flex-col items-center'}>
      {imgSrc && (
        <Image src={imgSrc} alt={title} height={150} width={150} priority />
      )}
      <Typography
        variant="h6"
        sx={{ mt: 6, textAlign: { md: 'center', lg: 'right' } }}
        {...titleProps}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{ mt: 1, mb: 6, textAlign: { md: 'center', lg: 'right' } }}
        {...descriptionProps}
      >
        {description}
      </Typography>
      {enableButton && (
        <Box {...buttonContainerProps}>
          <Link href={buttonLink || '#'} {...buttonLinkProps}>
            <Button variant="contained" {...buttonProps}>
              {buttonText}
            </Button>
          </Link>
        </Box>
      )}
    </Box>
  );
};

// ======================= EXPORT
export * from './props';
export default EmptyView;
